import React from 'react';
import { GiftIcon, CheckIcon } from 'lucide-react';
import { ExpandableSection } from './ExpandableSection';
export function BonusSection() {
  return <section className="bg-white py-16 md:py-24" data-id="element-155">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-156">
        {/* Intro Transition */}
        <div className="text-center mb-16 space-y-6" data-id="element-157">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900" data-id="element-158">
            Y eso no es todo.
          </h2>
          <p className="text-xl text-gray-700 leading-relaxed max-w-2xl mx-auto" data-id="element-159">
            Porque cuando tomás acción hoy, te llevo la mano hasta el primer
            resultado real.
          </p>
          <p className="text-xl text-gray-700 leading-relaxed font-medium max-w-2xl mx-auto bg-orange-50 p-6 rounded-xl border border-orange-100" data-id="element-160">
            No te doy solo la guía.
            <br data-id="element-161" />
            <span className="text-orange-600 font-bold" data-id="element-162">
              Te doy todo lo que necesitás para que funcione desde el primer
              día.
            </span>
          </p>
        </div>

        {/* Bonus Cards */}
        <div className="space-y-12" data-id="element-163">
          {/* Bonus 1 */}
          <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden flex flex-col md:flex-row" data-id="element-164">
            <div className="md:w-2/5 bg-gray-50 p-6 flex items-center justify-center" data-id="element-165">
              <img src="https://cdn.magicpatterns.com/uploads/rT4ezts7uuStAPPr8ZbeW2/Bono_1.png" alt="Kit Express de Salida Sin Drama" className="w-full max-w-xs rounded-lg shadow-md" data-id="element-166" />
            </div>
            <div className="md:w-3/5 p-8 flex flex-col justify-center" data-id="element-167">
              <div className="flex items-center gap-2 mb-3" data-id="element-168">
                <GiftIcon className="w-6 h-6 text-orange-600" data-id="element-169" />
                <span className="text-orange-600 font-bold tracking-wide uppercase text-sm" data-id="element-170">
                  Bono #1
                </span>
              </div>
              <h3 className="text-2xl font-bold text-navy-900 mb-2" data-id="element-171">
                Kit Express de Salida Sin Drama
              </h3>
              <p className="inline-block bg-green-100 text-green-800 font-medium px-3 py-1 rounded-full text-sm mb-6" data-id="element-172">
                Valor real: $19.000 ARS — Tuyo gratis hoy
              </p>

              <ExpandableSection buttonText="Ver detalles del kit" buttonTextExpanded="Ocultar detalles" preview={<div className="space-y-4 text-gray-700" data-id="element-174">
                    <p data-id="element-175">
                      Hay un momento crítico que la mayoría ignora. No es cuando
                      tu perro llora. No es cuando destruye. Es los 10 minutos
                      antes de que toques la llave.
                    </p>
                    <p data-id="element-176">
                      Ese momento define todo lo que pasa después. Este kit te
                      da una secuencia exacta, paso a paso, para que tu salida
                      deje de ser un evento emocional gigante y se convierta en
                      algo predecible, neutro y seguro para tu perro.
                    </p>
                  </div>} fullContent={<div className="mt-6 space-y-4 text-gray-700" data-id="element-177">
                    <p className="font-semibold text-navy-900" data-id="element-178">
                      Vas a saber exactamente:
                    </p>
                    <ul className="space-y-3" data-id="element-179">
                      <li className="flex gap-3" data-id="element-180">
                        <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-181" />{' '}
                        qué hacer en los 10 minutos previos a salir
                      </li>
                      <li className="flex gap-3" data-id="element-182">
                        <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-183" />{' '}
                        qué errores estás cometiendo sin darte cuenta
                      </li>
                      <li className="flex gap-3" data-id="element-184">
                        <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-185" />{' '}
                        cómo preparar el entorno en silencio
                      </li>
                      <li className="flex gap-3" data-id="element-186">
                        <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-187" />{' '}
                        cómo entregar el recurso de calma en el momento exacto
                      </li>
                      <li className="flex gap-3" data-id="element-188">
                        <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-189" />{' '}
                        cómo cruzar la puerta sin generar pánico
                      </li>
                    </ul>
                    <p className="pt-2" data-id="element-190">
                      Sin improvisación. Sin culpa. Sin drama. Incluye checklist
                      imprimible + hoja rápida de rescate para tener en el
                      celular.
                    </p>
                  </div>} data-id="element-173" />
              <div className="mt-6 pt-6 border-t border-gray-100" data-id="element-191">
                <p className="italic text-gray-600 font-medium" data-id="element-192">
                  "Cuanto más predecible sea tu salida, más seguro se siente tu
                  perro."
                </p>
              </div>
            </div>
          </div>

          {/* Bonus 2 */}
          <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden flex flex-col md:flex-row" data-id="element-193">
            <div className="md:w-2/5 bg-gray-50 p-6 flex items-center justify-center" data-id="element-194">
              <img src="https://cdn.magicpatterns.com/uploads/xuW8s6CjcWcKjQ19gSGMDV/Bono_2.png" alt="Checklist Casa Calma en 15 Minutos" className="w-full max-w-xs rounded-lg shadow-md" data-id="element-195" />
            </div>
            <div className="md:w-3/5 p-8 flex flex-col justify-center" data-id="element-196">
              <div className="flex items-center gap-2 mb-3" data-id="element-197">
                <GiftIcon className="w-6 h-6 text-orange-600" data-id="element-198" />
                <span className="text-orange-600 font-bold tracking-wide uppercase text-sm" data-id="element-199">
                  Bono #2
                </span>
              </div>
              <h3 className="text-2xl font-bold text-navy-900 mb-2" data-id="element-200">
                Checklist Casa Calma en 15 Minutos
              </h3>
              <p className="inline-block bg-green-100 text-green-800 font-medium px-3 py-1 rounded-full text-sm mb-6" data-id="element-201">
                Valor real: $22.000 ARS — Tuyo gratis hoy
              </p>

              <ExpandableSection buttonText="Ver detalles del checklist" buttonTextExpanded="Ocultar detalles" preview={<div className="space-y-4 text-gray-700" data-id="element-203">
                    <p data-id="element-204">
                      A veces el problema no está en la rutina. Está en la casa.
                      Mientras vos trabajás, tu perro no está descansando. Está
                      parado frente a la puerta. Escuchando el ascensor.
                      Vigilando la ventana.
                    </p>
                    <p data-id="element-205">
                      En estado de guardia permanente durante horas. No porque
                      sea ansioso "de naturaleza". Sino porque el entorno lo
                      obliga a vigilar cuando debería descansar. Este checklist
                      te ayuda a detectar en 15 minutos qué partes de tu casa
                      están disparando tensión sin que lo sepas.
                    </p>
                  </div>} fullContent={<div className="mt-6 space-y-4 text-gray-700" data-id="element-206">
                    <p className="font-semibold text-navy-900" data-id="element-207">
                      Vas a identificar:
                    </p>
                    <ul className="space-y-3" data-id="element-208">
                      <li className="flex gap-3" data-id="element-209">
                        <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-210" />{' '}
                        las zonas que mantienen a tu perro en alerta
                      </li>
                      <li className="flex gap-3" data-id="element-211">
                        <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-212" />{' '}
                        los estímulos visuales y sonoros que no estás viendo
                      </li>
                      <li className="flex gap-3" data-id="element-213">
                        <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-214" />{' '}
                        qué cambios simples podés hacer hoy sin gastar nada
                      </li>
                      <li className="flex gap-3" data-id="element-215">
                        <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-216" />{' '}
                        cómo crear una base segura real dentro de tu
                        departamento
                      </li>
                    </ul>
                    <p className="pt-2" data-id="element-217">
                      Incluye auditoría de hogar por zonas + hoja de observación
                      de detonantes + plantilla de mapa de entorno ideal.
                    </p>
                  </div>} data-id="element-202" />
              <div className="mt-6 pt-6 border-t border-gray-100" data-id="element-218">
                <p className="italic text-gray-600 font-medium" data-id="element-219">
                  "Una casa calma no es una casa vacía. Es una casa que tu perro
                  puede leer sin esfuerzo."
                </p>
              </div>
            </div>
          </div>

          {/* Bonus 3 */}
          <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden flex flex-col md:flex-row" data-id="element-220">
            <div className="md:w-2/5 bg-gray-50 p-6 flex items-center justify-center" data-id="element-221">
              <img src="https://cdn.magicpatterns.com/uploads/to5JRkd7eYfdiSbo8eZhWv/Bono_3.png" alt="Recetario de Enfoque y Masticación Tranquila" className="w-full max-w-xs rounded-lg shadow-md" data-id="element-222" />
            </div>
            <div className="md:w-3/5 p-8 flex flex-col justify-center" data-id="element-223">
              <div className="flex items-center gap-2 mb-3" data-id="element-224">
                <GiftIcon className="w-6 h-6 text-orange-600" data-id="element-225" />
                <span className="text-orange-600 font-bold tracking-wide uppercase text-sm" data-id="element-226">
                  Bono #3
                </span>
              </div>
              <h3 className="text-2xl font-bold text-navy-900 mb-2" data-id="element-227">
                Recetario de Enfoque y Masticación Tranquila
              </h3>
              <p className="inline-block bg-green-100 text-green-800 font-medium px-3 py-1 rounded-full text-sm mb-6" data-id="element-228">
                Valor real: $22.000 ARS — Tuyo gratis hoy
              </p>

              <ExpandableSection buttonText="Ver detalles del recetario" buttonTextExpanded="Ocultar detalles" preview={<div className="space-y-4 text-gray-700" data-id="element-230">
                    <p data-id="element-231">
                      Hay algo que casi ningún dueño sabe. La masticación no es
                      un capricho. Es el único mecanismo biológico que tiene tu
                      perro para bajar su cortisol cuando está solo.
                    </p>
                    <p data-id="element-232">
                      Si no le das algo para morder que sea suyo, va a elegir lo
                      que encuentre. Y lo que encuentra, en un departamento,
                      suele ser caro o irreemplazable. Este recetario te da
                      opciones concretas, simples y seguras para dejarle un
                      recurso de enfoque antes de salir.
                    </p>
                  </div>} fullContent={<div className="mt-6 space-y-4 text-gray-700" data-id="element-233">
                    <p className="font-semibold text-navy-900" data-id="element-234">Vas a tener:</p>
                    <ul className="space-y-3" data-id="element-235">
                      <li className="flex gap-3" data-id="element-236">
                        <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-237" />{' '}
                        5 opciones prácticas con ingredientes simples
                      </li>
                      <li className="flex gap-3" data-id="element-238">
                        <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-239" />{' '}
                        el momento exacto en que hay que entregarlo
                      </li>
                      <li className="flex gap-3" data-id="element-240">
                        <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-241" />{' '}
                        los errores más comunes que anulan el efecto
                      </li>
                      <li className="flex gap-3" data-id="element-242">
                        <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-243" />{' '}
                        checklist de seguridad para usarlo sin riesgos
                      </li>
                      <li className="flex gap-3" data-id="element-244">
                        <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-245" />{' '}
                        versión ultra simple para días con poco tiempo
                      </li>
                    </ul>
                    <p className="pt-2" data-id="element-246">
                      Sin gastar en productos caros. Sin improvisar. Sin ensayo
                      y error costoso.
                    </p>
                  </div>} data-id="element-229" />
              <div className="mt-6 pt-6 border-t border-gray-100" data-id="element-247">
                <p className="italic text-gray-600 font-medium" data-id="element-248">
                  "No se trata de distraerlo. Se trata de darle una herramienta
                  real para que su sistema nervioso baje de intensidad."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}